import React from 'react'
import { Box } from '@mui/material'
import { SurveyQuestionType } from '../../../../models/Survey'
import LineChart from '../Charts/LineChart'
import MultiChoiceAndMultiSelectChart from '../Charts/MultiChoiceAndMultiSelectChart'
import BarChart from '../Charts/BarChart'
import Title from '../Charts/BarChart/Title'
import { statButtons } from '../constants'
import type { KeyStatSurveyItem, ReportsV2 } from '../../../../models/Report'
import StatisticBox from '../Charts/BarChart/StatisticBox'

interface SurveyReportChartProps {
  report: KeyStatSurveyItem
  surveyItem: KeyStatSurveyItem | null
  reports: ReportsV2
  selectedTrend: number
  showSlice: boolean
  parsedSettings: any
  questionNumber: number
}

const SurveyReportChart: React.FC<SurveyReportChartProps> = ({
  report,
  surveyItem,
  reports,
  selectedTrend,
  showSlice,
  parsedSettings,
  questionNumber
}) => {
  const [selectedStat, setSelectedStat] = React.useState(statButtons[0].value)
  const questionType = report.itemType
  const isMultiSelectOrMultiChoice = questionType === SurveyQuestionType.MultiSelect || questionType === SurveyQuestionType.MultipleChoice
  const titleText = `${questionNumber + 1}. ${report.prompt}`
  let chart: React.ReactNode
  switch (true) {
    case selectedTrend > 2 && isMultiSelectOrMultiChoice:
      chart = <MultiChoiceAndMultiSelectChart report={report} questionTitle={titleText} titles={reports?.titles} />
      break
    case selectedTrend > 2:
      chart = (
        <LineChart
          report={report}
          titles={reports?.titles}
          titleComponent={<Title selectedStat={selectedStat} setSelectedStat={setSelectedStat} titleText={titleText} reports={reports} surveyItem={surveyItem} calculations={surveyItem?.calculations ?? []} />}
          selectedStat={selectedStat}
        />
      )
      break
    default:
      chart = (
        <BarChart
          chartKey={questionNumber}
          report={report}
          showPercents={selectedTrend ? true : parsedSettings?.chartSettings?.percentage ?? false}
          showSlice={showSlice}
          titles={reports?.titles}
          titleComponent={<Title titleText={titleText} reports={reports} surveyItem={surveyItem} calculations={surveyItem?.calculations ?? []} />}
          statisticBox={<StatisticBox calculations={surveyItem?.calculations} />}
        />
      )
  }

  return (
    <Box key={questionNumber} sx={{ mb: 3 }}>
      {chart}
    </Box>
  )
}

export default SurveyReportChart
